import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridApi, GridOptions, GridReadyEvent, ICellRendererParams, RowSelectedEvent } from 'ag-grid-community'; // GridReadyEvent used in gridOptions callback
import { GridPersist } from '../../../grid/grid-persist';
import { LeaPDPersonSearchResultDto, LeaSiteCodeDto } from '../../../services/api.service';

@Component({
  selector: 'cert-pd-advanced-person-search-results-grid',
  standalone: false,
  templateUrl: './pd-advanced-person-search-results-grid.component.html',
})
export class ProfessionalDevelopmentAdvancedPersonSearchResultsGridComponent {
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  @Input() results: LeaPDPersonSearchResultDto[] = [];
  @Input() leaSiteCodes: LeaSiteCodeDto[] = [];
  @Input() selectedPersonIds: number[] = [];

  @Output() select = new EventEmitter<LeaPDPersonSearchResultDto>();
  @Output() deselect = new EventEmitter<LeaPDPersonSearchResultDto>();

  protected gridApi!: GridApi;
  protected errorEmitter = new EventEmitter<any>();

  protected colDefs: ColDef<LeaPDPersonSearchResultDto>[] = [
    {
      field: 'isOnLeaRoster',
      headerName: '',
      sortable: false,
      filter: false,
      cellRenderer: (params: ICellRendererParams<LeaPDPersonSearchResultDto, boolean>) =>
        params.value ? '' : '<span class="badge badge-danger">Not On Roster</span>',
      width: 120,
      minWidth: 120,
      maxWidth: 120,
    },
    {
      headerName: 'Educator Name',
      valueGetter: (params: any) => {
        return `${params.data.lastName}, ${params.data.firstName}`;
      },
    },
    {
      field: 'ein',
      headerName: 'EIN',
    },
    {
      field: 'leaSites',
      headerName: 'Location(s)',
      sort: 'asc',
      minWidth: 400,
    },
  ];

  gridPersist = new GridPersist('cert-pd-advanced-person-search-results-grid');

  protected gridOptions: GridOptions<LeaPDPersonSearchResultDto> = this.gridPersist.setup({
    domLayout: 'autoHeight',

    rowSelection: { mode: 'multiRow', enableClickSelection: false },
    pagination: true,
    paginationPageSize: 25,
    paginationPageSizeSelector: [10, 25, 50, 100],
    context: { componentParent: this },
    defaultColDef: {
      sortable: true,
      resizable: true,
      suppressMovable: true,
      filter: 'agTextColumnFilter',
    },
    columnDefs: this.colDefs,
    onGridReady: (params: GridReadyEvent<LeaPDPersonSearchResultDto>) => {
      this.gridApi = params.api;
    },
    onRowSelected: (event: RowSelectedEvent<LeaPDPersonSearchResultDto>) => {
      if (event.data) {
        if (event.node.isSelected()) {
          this.onSelect(event.data);
        } else {
          this.onDeselect(event.data);
        }
      }
    },
  });

  constructor() {}

  resetFilters() {
    if (this.gridApi) {
      this.gridApi.setFilterModel(null);
      this.gridPersist.resetAndSaveGrid(this.gridApi);
    }
  }

  onSelect(person: LeaPDPersonSearchResultDto) {
    this.select.emit(person);
  }

  onDeselect(person: LeaPDPersonSearchResultDto) {
    this.deselect.emit(person);
  }

  isSelected(personId: number) {
    return this.selectedPersonIds.includes(personId);
  }
}
